import React from 'react';
import MyCard from "../../components/myCard";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import loadParameters from "../../components/loadParameters";
import {Button} from "react-bootstrap";
import {isObject} from 'lodash';
import RemiseMemoire from "./remise";
import ScreenComponent from "../../components/screenComponent";
import {Link, withRouter} from "react-router-dom";
import Security from "../../components/security";
import DonneesMemoire from "../../forms/donneesMemoire";

class Memoire extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            memoire: {},
            disabled: true,
            validateForm: false,
            Remis: false,
            disabledIDM: false,
            IDMRemis: false,
        };
        this.state.parameters = [];
        this.state.parameters["MembrePersonnelID"] = [];
        this.state.parameters["LangueMemoireID"] = [];
        this.state.parameters["SessionAAActiveID"] = [];
        this.state.parameters["SessionID"] = [];
        this.state.parameters["StatutConfidentialiteID"] = [];
    }

    async componentDidMount() {
        super.componentDidMount();

        await loadParameters(this, "MembrePersonnelID,LangueMemoireID,LangueDefenseID,SessionAAActiveID, SessionID,StatutConfidentialiteID");

        this.state.parameters["SessionID"] = this.state.parameters["SessionAAActiveID"].filter((f) => {
            return !f.label.includes("Septembre")
        });

        this.state.parameters["SessionIDIDM"] = this.state.parameters["SessionAAActiveID"];

        let {body} = await Get(`/v1/extranet/student/${screens.Memoire}`);

        this.setState({
            memoire: body,
            disabled: !!body.MemoireTitre || !Security.findAccess(screens.Memoire).canUpdate,
            IDMRemis: !!body.MemoireResume,
        });

        if (body.MemoireTitre) {
            ({body} = await Get(`/v1/extranet/student/${screens.RemiseMemoire}`));

            this.setState({
                Remis: body.Remis
            });
        }
    }

    changePromoteur = option => {
        this.setState({
            memoire: {
                ...this.state.memoire,
                MembrePersonnelID: option
            }
        });
    };

    changeLangue = option => {
        this.setState({
            memoire: {
                ...this.state.memoire,
                LangueMemoireID: option
            }
        });
    };

    changeSession = option => {
        this.setState({
            memoire: {
                ...this.state.memoire,
                SessionID: option
            }
        });
    };

    async save(data) {
        data["MemoireID"] = this.state.memoire.MemoireID;

        Object.entries(data).forEach(([key, value]) => {
            if (isObject(value)) data[key] = value.value
        });

        await Post(`/v1/extranet/student/Memoire`, data, "Sauvegarde en cours..", {render: "Mémoire sauvegardé !"}, {render: "Erreur lors de la sauvegarde"});

        this.componentDidMount();
    }

    renderText() {
        return (
            <>
                <p>
                    La formulation actuelle du titre est <b>provisoire</b>, l’étudiant aura la possibilité de modifier le titre
                    lors du dépôt de l’IDM et finalement, lors de la remise du mémoire.
                    Il est demandé à l’étudiant de prévenir <a
                    href={"mailto:memoires@ichec.be?subject=[ICHEC Student] Modification titre mémoire"}>l’USM </a>uniquement
                    en cas de changement de thématique validé par le promoteur.
                </p>
                <br/>

                <h4>« {this.state.memoire.MemoireTitre} »</h4>

                <p>
                    <u>Promoteur</u>: {this.state.parameters.MembrePersonnelID.filter(f => f.value === this.state.memoire.MembrePersonnelID).map(m => m.label)}
                </p>
                <p>
                    <u>Langue de
                        rédaction</u>: {this.state.parameters.LangueMemoireID.filter(f => f.value === this.state.memoire.LangueMemoireID).map(m => m.label)}
                </p>
            </>
        );
    }

    renderTextIDM() {
        return (
            <>
                <p>
                    Les Informations relatives à la Défense de votre Mémoire (IDM) ont bien été enregistrées.
                </p>
                <p>
                    Votre numéro de téléphone sera utilisé s’il y avait besoin de vous contacter en urgence dans le cadre
                    de l’organisation de votre défense de mémoire.
                    <br/>
                    Veuillez vérifier celui-ci sur via l'onglet&nbsp;
                    <Link target="_blank" to={process.env.APP_ROOT + "contacts"}>
                        mes données.
                    </Link>
                    &nbsp;
                    Pour toute demande de modification de vos données, veuillez prendre contact par mail avec le <a href={"mailto:secretariat.academique@ichec.be?subject=[ICHEC Student] Mise à jour numéro téléphone"}>secrétariat</a>.
                </p>

                <p>
                    L’étudiant aura la possibilité de modifier le titre lors de la remise du mémoire.
                    Il est demandé à l’étudiant de prévenir <a href={"mailto:memoires@ichec.be?subject=[ICHEC Student] Modification titre mémoire"}>l’USM </a>uniquement
                    en cas de changement de thématique validé par le promoteur.
                </p>
                <br/>

                {this.state.parameters.StatutConfidentialiteID.filter(f => f.value === this.state.memoire.StatutConfidentialiteID).map(m => m.label) == "Confidentialité acceptée"
                    ?
                    <p>
                        <b> Mise à jour du statut confidentialité : acceptée. </b>
                    </p>
                    :
                    <p></p>
                }

                <u>Titre</u>:
                <h4>« {this.state.memoire.MemoireTitre} »</h4>

                {this.state.memoire.MemoireTitreModification === ""
                || this.state.memoire.MemoireTitreModification == null
                || this.state.memoire.MemoireTitreModification == undefined
                    ?
                    <p></p>
                    :
                    <p>
                        <u>Titre provisoire modifié du mémoire :</u>
                        <h4>« {this.state.memoire.MemoireTitreModification} »</h4>
                    </p>
                }

                <blockquote className="mb-5">
                    <u> Mots-clés</u>:    <footer className="blockquote-footer">{this.state.memoire.MemoireMotsClefs}</footer>
                </blockquote>
                <p>
                    <u>Session</u>: {this.state.parameters.SessionIDIDM.filter(f => f.value === this.state.memoire.SessionID).map(m => m.label)}
                </p>
                <p>
                    <u>Promoteur</u>: {this.state.parameters.MembrePersonnelID.filter(f => f.value === this.state.memoire.MembrePersonnelID).map(m => m.label)}
                </p>
                <p>
                    <u>Langue de
                        rédaction</u>: {this.state.parameters.LangueMemoireID.filter(f => f.value === this.state.memoire.LangueMemoireID).map(m => m.label)}
                </p>
                <p>
                    <u>Langue de
                        défense</u>: {this.state.parameters.LangueDefenseID.filter(f => f.value === this.state.memoire.LangueDefenseID).map(m => m.label)}
                </p>
                <p>
                    <u>Résumé du mémoire</u>: {this.state.memoire.MemoireResume}
                </p>
            </>
        );
    }

    btnRemise() {
        return (
            Security.canAccess(screens.RemiseMemoire)[0] &&
            <section className={"text-center"}>
                <Link to={process.env.APP_ROOT + "memoire/remise"}>
                    <Button variant={"secondary"} size={"lg"}>Remise du mémoire</Button>
                </Link>
            </section>
        );
    }

    btnRemiseIDM() {
        return (
            <section className={"text-center"}>
                <Link to={process.env.APP_ROOT + "memoire/idm"}>
                    <Button variant={"secondary"} size={"lg"}> Remise IDM </Button>
                </Link>
            </section>
        );
    }

    render() {
        return (
            <>
                {/*
                // Etudiant remet Données mémoire > IDM > mémoire final sur la ligne du temps et en priorité

                // DonneesMemoire = données mémoire remise Q1 avant IDM

                // this.state.IDMRemis = IDM remis
                // btnRemiseIDM = remise IDM

                // this.state.Remis = mémoire final remis
                // btnRemise = remise mémoire final
                */}


                {this.state.Remis ? <RemiseMemoire/> : null}

                {this.state.IDMRemis
                ?
                    <section>
                        <MyCard header={"Informations relatives à la Défense du Mémoire (IDM)"}
                                body={this.renderTextIDM()}
                        /><br/>
                        {!this.state.Remis ? this.btnRemise() : null }
                    </section>
                    :
                <section>
                    <MyCard header={"Données de mon mémoire"}
                            body={this.state.disabled ? this.renderText() :
                                <DonneesMemoire onSubmit={this.save.bind(this)}
                                                parameters={this.state.parameters}/>}/>
                    <br/>
                </section>}

                { (this.state.disabled && Security.findAccess(screens.InformationsRelativesDefenseMemoire).canAccess &&
                    !this.state.IDMRemis )
                    ?
                    this.btnRemiseIDM()
                    :
                    null
                }
            </>
        );
    }
}

export default withRouter(Memoire);